export default __webpack_public_path__ + "static/media/Agrivore_NavLogo.4ff30261.png";